import React from 'react';
// To change it's css goto _sidebar.scss
const AboutOne = ( props ) => {
    return (
        <div className={`edu-blog-widget ${ props.style2 === 'enable' ? 'edu-about-widget-2' : '' } widget-about ${ props.extraClass || '' }`}>
            <div className="inner">
                <h5 className="widget-title yourProfile">Your Profile</h5>
                <p>Login in to see details</p>
                <div className="content">
                    <div className="about-wrapper">
                        <div className="thumbnail">
                            <img src="/customizedimages/elon.jpg" alt="Blog Images" />
                        </div>
                        <div className="about-content">
                            <h6 className="title">Elon Musk</h6>
                            <p>Founder of multi-million dollar companies. A mentor and angel investor by profession.</p>
                            <ul className="social-share icon-transparent justify-content-center">
                                <li><a href="#"><i className="icon-Fb"></i></a></li>
                                <li><a href="#"><i className="icon-linkedin"></i></a></li>
                                <li><a href="#"><i className="icon-Pinterest"></i></a></li>
                                <li><a href="#"><i className="icon-Twitter"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutOne;